import { render } from "./GeneralSettingsCard.vue?vue&type=template&id=0b565197&scoped=true&ts=true"
import script from "./GeneralSettingsCard.vue?vue&type=script&lang=ts"
export * from "./GeneralSettingsCard.vue?vue&type=script&lang=ts"

import "./GeneralSettingsCard.vue?vue&type=style&index=0&id=0b565197&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b565197"]])

export default __exports__